import { render } from "./FinalVideo.vue?vue&type=template&id=351897ea"
import script from "./FinalVideo.vue?vue&type=script&lang=js"
export * from "./FinalVideo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\Vue3\\player-video-pepsi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__